export enum AuthenticationActionType {
  ERROR = 'ERROR',
  CANCEL = 'CANCEL',
  SIGN_IN = 'SIGN_IN',
  SUCCESS = 'SUCCESS',
  IMPERSONATION = 'IMPERSONATION',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_SEND_EMAIL = 'FORGOT_SEND_EMAIL',
  FORGOT_UPDATE_PASSWORD = 'FORGOT_UPDATE_PASSWORD'
}
